import React from "react";
import { Link } from "react-router-dom";
import "./Galleria.css";

import heroides1 from "../assets/Dipinti/1heroides1.jpg";
import heroides2 from "../assets/Dipinti/2heroides2.jpeg";
import heroides3 from "../assets/Dipinti/3heroides3.jpeg";
import medusa from "../assets/Dipinti/medusa.jpg";
import alledonne from "../assets/Dipinti/7Alledonne.jpg";
import amanta from "../assets/Dipinti/5amantha.jpg";
import marwa from "../assets/Dipinti/6Marwa.jpg";
import carolina from "../assets/Dipinti/8Carolina.jpg";
import viviana from "../assets/Dipinti/4Viviana.jpg";
import nelleforme from "../assets/Dipinti/nelleforme.png";
import studio1 from "../assets/Dipinti/studio1.jpeg";
import studiodue from "../assets/Dipinti/studiodue.jpeg";
import caramanu from "../assets/studi/1caramanu.jpg";
import salvatore from "../assets/studi/3salvatore.jpg";

// Tutta la galleria descritta come dati: per aggiungere/spostare
// un'opera basta modificare questo elenco.
const opere = [
  { tipo: "sezione", testo: "Ritratti" },
  { img: heroides1, titolo: "HEROIDES I", righe: ["olio e foglia oro su tela", "60 x 80 cm", "2020"] },
  { img: heroides2, titolo: "HEROIDES II", righe: ["olio e foglia oro su tela", "60 x 80 cm", "2020"] },
  { img: heroides3, titolo: "HEROIDES III", righe: ["olio e foglia oro su tela", "60 x 80 cm", "2021"] },
  { img: medusa, titolo: "MEDUSA TRIONFANTE DECOLLA PERSEO", righe: ["olio e foglia oro su tela", "80 x 120 cm", "2021"] },
  { img: alledonne, titolo: "A TUTTE LE DONNE LIBERE", righe: ["olio e foglia oro su tela", "40 x 50 cm", "2021"] },
  { img: amanta, titolo: "AMANTHA", righe: ["olio e foglia oro su tela", "40 x 50 cm", "2022"] },
  { img: marwa, titolo: "MARWA", righe: ["olio su tela", "40 x 50 cm", "2022"] },
  { img: carolina, titolo: "CAROLINA", righe: ["olio e foglia oro su tela", "30 x 40 cm", "2021"] },
  { img: viviana, titolo: "VIVIANA", righe: ["olio e foglia oro su tela", "50 x 70 cm", "2022"] },
  { tipo: "sezione", testo: "Altri Progetti" },
  { img: nelleforme, titolo: "NELLE FORME DI UN ALTRO DOLORE", righe: ["tecnica mista e foglia oro su tela", "90 cm", "2022"] },
  { img: studio1, titolo: "STUDIO", righe: ["tecnica mista su tela grezza", "55 x 65 cm", "2023"] },
  { img: studiodue, titolo: "STUDIO II", righe: ["tecnica mista su tela grezza", "55 x 65 cm", "2023"] },
  { img: caramanu, titolo: "CARA MANU", righe: ["collage su tela", "30 x 40 cm", "2022"] },
  { img: salvatore, titolo: "SALVATORE", righe: ["olio, tela grezza e gesso su tela", "100 x 100 cm", "2019"] },
];

const Ritratti = () => {
  return (
    <div className="galleria">
      {opere.map((o, i) =>
        o.tipo === "sezione" ? (
          <div className="sezione" key={i}>
            <span>{o.testo}</span>
          </div>
        ) : (
          <figure className="opera" key={i}>
            <img src={o.img} alt={o.titolo} draggable="false" />
            <figcaption className="didascalia">
              <strong>{o.titolo}</strong>
              {o.righe.map((r, j) => (
                <span key={j}>{r}</span>
              ))}
            </figcaption>
          </figure>
        )
      )}

      <Link to="/Home" className="torna">
        Torna alla home
      </Link>
    </div>
  );
};

export default Ritratti;
